import * as React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { ContainerOverviewGrid } from "./ContainerOverviewGrid";
import PageHeader from "../../../Layout/Header/PageHeader";
import { MdmTabs } from "../../../Layout/Tabs/MdmTabs";
import { INFORMATION } from "../../../Layout/Tabs/MdmTabPanelConstants";
import { PdsrInformationForm } from "./PdrsInformationForm";
import PageHeaderButton from "../../../Layout/Header/PageHeaderButton";
import { PdsrEditItem, pdsrEditItemDefaultValues } from "./PdsrEditItem";
import { isFormSubmitForbidden } from "../../../Forms/isFormSubmitForbidden";
import { resetFormStateAndKeepFormValues } from "../../../Forms/resetFormStateAndKeepFormValues";
import { useFetchPdsr } from "./Hooks/useFetchEditPdsrItem";
import { useUpdatePdsr } from "./Hooks/useUpdatePdsr";
import { useIsUserInRoles } from "../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export default function EditPdsr() {
  const { pdsrId } = useParams();
  const { data: pdsr } = useFetchPdsr(pdsrId);
  const { mutate: savePdsr } = useUpdatePdsr(pdsrId);
  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);

  const methods = useForm<PdsrEditItem>({
    defaultValues: pdsrEditItemDefaultValues,
    disabled: !isUserInAdminNetworkRole,
  });

  useEffect(() => {
    methods.reset(pdsr);
    return () => methods.reset(pdsrEditItemDefaultValues);
  }, [pdsr, methods, methods.reset]);

  return (
    <div>
      <PageHeader headerText="Edit PDSR">
        <PageHeaderButton
          onClick={methods.handleSubmit((values: PdsrEditItem) => {
            savePdsr(values);
            resetFormStateAndKeepFormValues(methods);
          })}
          disabled={isFormSubmitForbidden(methods.formState)}
        >
          Save
        </PageHeaderButton>
      </PageHeader>
      <MdmTabs
        tabs={[
          {
            index: 0,
            label: INFORMATION,
            content: (
              <FormProvider {...methods}>
                <PdsrInformationForm />
              </FormProvider>
            ),
          },
          {
            index: 1,
            label: "CONTAINER TYPES",
            content: <ContainerOverviewGrid pdsrId={pdsrId} />,
          },
        ]}
      />
    </div>
  );
}
